import { memo, ReactNode } from 'react'
import { SxProps } from '@mui/material'
import { filterDropdownValueStyles as styles } from './FilterDropdownValue.style'
import Text from '../../Text'

interface DropdownValueProps {
  open?: boolean
  selectedValue: unknown
  label: ReactNode
  labelValue?: string
  selectedValueLabel?: string
  disabled: boolean
}

function DropdownValue({
  selectedValue,
  open,
  label,
  labelValue,
  selectedValueLabel,
  disabled,
}: DropdownValueProps) {
  const isSelected = Array.isArray(selectedValue)
    ? selectedValue.length > 0
    : Boolean(selectedValue)

  if (!isSelected) {
    return (
      <Text
        sx={
          {
            ...styles.dropdownSelectedValue,
            ...(open && styles.dropdownSelectedValueActive),
            ...(disabled && styles.disabled),
          } as SxProps
        }>
        {label}
      </Text>
    )
  }
  return (
    <Text
      sx={
        {
          ...styles.dropdownSelectedValue,
          ...(isSelected && styles.dropdownSelectedValueActive),
        } as SxProps
      }>
      {labelValue ?? selectedValueLabel ?? (selectedValue as string)}
    </Text>
  )
}

export default memo(DropdownValue)
